import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import NavbarManager, { infoUtente, loadNav } from "./Navbar";
import Table from "../../components/Table";
import PopUp from "../../components/PopUp";
import Combobox from "../../components/Combobox";
import Loader from "../../components/Loader";
import Alert from "../../components/Alert";
import Button from "../../components/Button";
import BarChart from "../../components/BarChart";
import { X, Users, Wrench, Factory } from "lucide-react";
import { useDeviceLayout } from "../../components/DeviceLayoutProvider";

let stati = [];
const RowPCI = ({ data, onCheckboxChange }) => {
    return (
        <div className="flex flex-row">
            <div className="grid grid-cols-3 py-4 border-b-2 border-gray-300 dark:border-neutral-700 w-full">
                <div className="flex items-center pl-2 ">
                    {data.value.DataIntervento}
                </div>
                <div className="flex items-center pl-2 ">
                    {data.value.NomeAzienda}
                </div>
                <div className="flex items-center pl-2 ">
                    {data.value.EmailUtente}
                </div>
            </div>
        </div>
    );
};

const RowMobile = ({ data, headers, keyForPreview }) => {
    return (
        <>
            {
                headers.map(header => (
                    !keyForPreview.includes(header.key) && (
                        <div key={`mobile-detail-${header.key}`} className="mb-2">
                            <span className="font-medium text-sm text-gray-500 dark:text-gray-400">
                                {header.label}:
                            </span>
                            <span className={`ml-1 text-sm`} style={header.key === "StatoAssunto" ? { color: stati.find((d) => d.Nome === data.value[header.key])?.Colore } : {}}>
                                {data.value[header.key]}
                            </span>
                        </div>
                    )
                ))
            }
        </>
    );
};

const Dash = () => {
    const [isLoading, setIsLoading] = useState(true);
    const navigate = useNavigate();
    const [showAlert, setShowAlert] = useState(false);
    const [alertInfo, setAlertInfo] = useState({ type: "info", text: "", onClose: () => setShowAlert(false), needConfirm: false, onConfirm: () => { } });
    const { isLittle } = useDeviceLayout();
    const [barChartData, setBarChartData] = useState([]);
    const [conteggi, setConteggi] = useState({ Aziende: 0, Componenti: 0, Utenti: 0 });
    const [dataInterventi, setDataInterventi] = useState([]);
    const [isInterventiVisible, setIsInterventiVisible] = useState(false);
    const [selectedIntervento, setSelectedIntervento] = useState(null);
    const [infoManut, setInfoManut] = useState([]);
    const [dataScadenze, setDataScadenze] = useState([]);
    const [isScadenzeVisible, setIsScadenzeVisible] = useState(false);
    const [isMailVisible, setIsMailVisible] = useState(false);
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [utenti, setUtenti] = useState([]);
    const [selectedScadenza, setSelectedScadenza] = useState(null);

    useEffect(() => {
        onload();
    }, []);

    useEffect(() => {
        if (isMailVisible) {
            const loadUtenti = async () => {
                setIsLoading(true);
                try {
                    const r = await fetch("/getUtentiByGestione", {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify({
                            CodiceDominio: infoUtente["CodiceDominio"],
                            IDAzienda: selectedScadenza.value["IDAzienda"]
                        }),
                    });

                    const rd = await r.json();

                    if (r.status === 500) {
                        console.log(rd.error);
                        setAlertInfo({ type: "error", text: rd.error, onClose: () => setShowAlert(false), needConfirm: false });
                        setShowAlert(true);
                        setIsMailVisible(false);
                    } else {
                        setUtenti(rd.filter((d) => d["DataEliminazione"] === null));
                    }
                } catch (error) {
                    console.log(error);
                    setAlertInfo({ type: "error", text: "Errore nel caricamento degli installatori, riprova più tardi", onClose: () => setShowAlert(false), needConfirm: false });
                    setShowAlert(true);
                    setIsMailVisible(false);
                }
                setIsLoading(false);
            };
            loadUtenti();
        }
    }, [isMailVisible]);

    const onload = async () => {
        setIsLoading(true);
        await loadNav();
        try {
            const r1 = await fetch("/getBarChartData", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ CodiceDominio: infoUtente["CodiceDominio"] })
            });
            const rd1 = await r1.json();
            if (r1.status === 500) {
                console.log(rd1.error);
                setAlertInfo({ type: "error", text: rd1.error, onClose: () => { setShowAlert(false); navigate('/'); }, needConfirm: false });
                setShowAlert(true);
            } else {
                setBarChartData(rd1);

                const r2 = await fetch("/getConteggi", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({ CodiceDominio: infoUtente["CodiceDominio"] })
                });
                const rd2 = await r2.json();
                if (r2.status === 500) {
                    console.log(rd2.error);
                    setAlertInfo({ type: "error", text: rd2.error, onClose: () => { setShowAlert(false); navigate('/'); }, needConfirm: false });
                    setShowAlert(true);
                } else {
                    setConteggi(rd2);

                    const r3 = await fetch('/getStati', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                            CodiceDominio: infoUtente.CodiceDominio
                        })
                    });
                    const rd3 = await r3.json();
                    if (r3.status === 500) {
                        console.log(rd3.error);
                        setAlertInfo({ type: "error", text: rd3.error, onClose: () => { setShowAlert(false); navigate('/'); }, needConfirm: false });
                        setShowAlert(true);
                    }
                    else {
                        stati = rd3;

                        const r4 = await fetch('/getReport', {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json'
                            },
                            body: JSON.stringify({
                                CodiceDominio: infoUtente.CodiceDominio
                            })
                        });
                        const rd4 = await r4.json();
                        if (r4.status === 500) {
                            console.log(rd4.error);
                            setAlertInfo({ type: "error", text: rd4.error, onClose: () => { setShowAlert(false); navigate('/'); }, needConfirm: false });
                            setShowAlert(true);
                        } else {
                            setDataInterventi(rd4.sort((a, b) => new Date(b["DataInizio"]) - new Date(a["DataInizio"])).map(item => ({ value: { ...item, "DataIntervento": item.DataFine !== null ? item.DataInizio + " - " + item.DataFine : item.DataInizio } })));

                            const r5 = await fetch('/getComponentiInScadenza', {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json'
                                },
                                body: JSON.stringify({
                                    CodiceDominio: infoUtente.CodiceDominio
                                })
                            });

                            const rd5 = await r5.json();
                            if (r5.status === 500) {
                                console.log(rd5.error);
                                setAlertInfo({ type: "error", text: rd5.error, onClose: () => { setShowAlert(false); navigate('/'); }, needConfirm: false });
                                setShowAlert(true);
                            } else {
                                setDataScadenze(rd5.map(item => ({ value: { ...item, impianto: item.NomeImpianto + (item.DescrizioneImpianto !== "" ? " - " + item.DescrizioneImpianto : ""), categoria: item.NomeCategoria + (item.DescrizioneCategoria !== "" ? " - " + item.DescrizioneCategoria : "") } })));
                            }
                        }
                    }
                }
            }
        } catch (error) {
            console.log(error);
            setAlertInfo({ type: "error", text: "Errore nel caricamento dei componenti, riprova più tardi", onClose: () => { setShowAlert(false); navigate('/'); }, needConfirm: false });
            setShowAlert(true);
        }
        setIsLoading(false);
    };

    const loadManutenzioniByReport = async (idReport) => {
        setIsLoading(true);
        try {
            const r = await fetch('/getManutenzioniByReport', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    "CodiceDominio": infoUtente.CodiceDominio,
                    "IDReport": idReport
                })
            });
            const rd = await r.json();
            if (r.status === 500) {
                console.log(rd.error);
                setAlertInfo({ type: "error", text: rd.error, onClose: () => { setShowAlert(false); navigate('/manager/dash'); }, needConfirm: false });
                setShowAlert(true);
            } else {
                setInfoManut(rd.map(item => ({ value: item })));
            }
        } catch (error) {
            console.log(error);
            setAlertInfo({ type: "error", text: "Errore nel caricamento della pagina, riprovare più tardi", onClose: () => { setShowAlert(false); navigate('/manager/dash'); }, needConfirm: false });
            setShowAlert(true);
        }
        setIsLoading(false);
    };

    const handleRimuoviUtente = (ID) => {
        setSelectedUsers(selectedUsers.filter((d) => d["ID"] !== Number(ID)));
    };

    const handleSendAll = async () => {
        setIsLoading(true);
        try {
            const r = await fetch("/sendManutenzioni", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    Utenti: utenti,
                    Componente: selectedScadenza.value
                })
            });

            if (r.status === 500) {
                const rd = await r.json();
                console.log(rd.error);
                setAlertInfo({ type: "error", text: rd.error, onClose: () => setShowAlert(false), needConfirm: false });
                setShowAlert(true);
                setIsMailVisible(false);
            }
            else {
                setIsLoading(false);
                setAlertInfo({ type: "success", text: "Mail inviata con successo a tutti gli installatori", onClose: () => { setShowAlert(false); setIsMailVisible(false); }, needConfirm: false });
                setShowAlert(true);
            }
        } catch (error) {
            console.log(error);
            setAlertInfo({ type: "error", text: "Errore nell'invio della mail, riprova più tardi", onClose: () => { setShowAlert(false); setIsMailVisible(false); }, needConfirm: false });
            setShowAlert(true);
            setIsMailVisible(false);
        }
    };

    const handleSend = async () => {
        setIsLoading(true);
        try {
            const r = await fetch("/sendManutenzioni", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    Utenti: selectedUsers,
                    Componente: selectedScadenza.value
                })
            });

            if (r.status === 500) {
                const rd = await r.json();
                console.log(rd.error);
                setAlertInfo({ type: "error", text: rd.error, onClose: () => setShowAlert(false), needConfirm: false });
                setShowAlert(true);
                setIsMailVisible(false);
            } else {
                setAlertInfo({ type: "success", text: "Mail inviata con successo", onClose: () => { setShowAlert(false); setIsMailVisible(false); }, needConfirm: false });
                setShowAlert(true);
            }
        } catch (error) {
            console.log(error);
            setAlertInfo({ type: "error", text: "Errore nell'invio della mail, riprova più tardi", onClose: () => { setShowAlert(false); setIsMailVisible(false); }, needConfirm: false });
            setShowAlert(true);
        }
        setIsLoading(false);
    };

    const addUser = (IDUtente) => {
        if (selectedUsers.includes(utenti.find((d) => d["ID"] === Number(IDUtente)))) {
            setAlertInfo({ type: "info", text: "Installatore già selezionato", onClose: () => setShowAlert(false), needConfirm: false });
            setShowAlert(true);
            return;
        }
        setSelectedUsers([...selectedUsers, utenti.find((d) => d["ID"] === Number(IDUtente))]);
    };

    return (
        <div className="h-[100svh]">
            <NavbarManager page={"DASHBOARD"} />
            {isLoading && <Loader />}
            {showAlert && <Alert type={alertInfo.type} text={alertInfo.text} onClose={alertInfo.onClose} needConfirm={alertInfo.needConfirm} onConfirm={alertInfo.onConfirm} />}
            <div className="h-[93%] overflow-y-auto px-4">
                {
                    isLittle ? (
                        <div className="flex flex-col w-full">
                            <div className="grid grid-cols-3 gap-3 mt-4">
                                <Button type="full" onClick={() => { navigate('/manager/clienti') }} color="blue">
                                    <div className="flex justify-between items-center w-full">
                                        <Factory size={48} strokeWidth={2} />
                                        <div className="flex flex-col">
                                            <div className="text-2xl font-semibold">{conteggi.Aziende}</div>
                                            <div className="flex justify-end items-center text-lg mr-1">Clienti</div>
                                        </div>
                                    </div>
                                </Button>
                                <Button type="full" onClick={() => { navigate('/manager/anagrafica') }} color="green">
                                    <div className="flex justify-between items-center w-full">
                                        <Wrench size={48} strokeWidth={2} />
                                        <div className="flex flex-col">
                                            <div className="text-2xl font-semibold">{conteggi.Componenti}</div>
                                            <div className="flex justify-end items-center text-lg mr-1">Articoli</div>
                                        </div>
                                    </div>
                                </Button>
                                <Button type="full" onClick={() => { navigate('/manager/installatori') }} color="yellow">
                                    <div className="flex justify-between items-center w-full">
                                        <Users size={48} strokeWidth={2} />
                                        <div className="flex flex-col">
                                            <div className="text-2xl font-semibold">{conteggi.Utenti}</div>
                                            <div className="flex justify-end items-center text-lg mr-1">Installatori</div>
                                        </div>
                                    </div>
                                </Button>
                            </div>
                            <div className="grid grid-cols-1 gap-3 mt-3">
                                <div
                                    className="pb-6 pl-6 pt-2 rounded-2xl bg-gray-200 dark:bg-neutral-800 h-[30vh]"
                                    onClick={() => { setIsScadenzeVisible(true) }}
                                >
                                    <BarChart
                                        data={barChartData}
                                        maxValue={Math.max(...barChartData.map(d => d.value))}
                                        title="Scadenze articoli"
                                    />
                                </div>
                                <div className="p-4 rounded-2xl bg-gray-200 dark:bg-neutral-800">
                                    <div className="flex justify-self-center text-xl font-bold my-4 text-center text-black dark:text-white uppercase">ULTIMI INTERVENTI</div>
                                    <Table
                                        headers={[
                                            { label: 'Data/Date Intervento', key: 'DataIntervento' },
                                            { label: 'Nome Cliente', key: 'NomeAzienda' },
                                            { label: 'Email Installatore', key: 'EmailUtente' }
                                        ]}
                                        keyForPreview={["DataIntervento"]}
                                        data={dataInterventi}
                                        setData={setDataInterventi}
                                        renderRowPC={({ rowData, handleRowCheckboxChange }) => <RowPCI data={rowData} onCheckboxChange={handleRowCheckboxChange} />}
                                        renderRowMobile={({ rowData, headers, keyForPreview }) => <RowMobile data={rowData} headers={headers} keyForPreview={keyForPreview} />}
                                        itemsPC={3}
                                        itemsMobile={3}
                                        needResearch={true}
                                        clickableRow={true}
                                        actionRow={async (row, rowIndex) => {await loadManutenzioniByReport(row.value.ID); setSelectedIntervento(row); setIsInterventiVisible(true); }}
                                        isBgLighter={true}

                                    />
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className="flex flex-col w-full">
                            <div className="grid grid-cols-3 gap-5 mt-5">
                                <Button type="full" onClick={() => { navigate('/manager/clienti') }} color="blue">
                                    <div className="flex justify-between items-center w-full">
                                        <Factory size={48} strokeWidth={2} />
                                        <div className="flex flex-col">
                                            <div className="text-4xl font-semibold">{conteggi.Aziende}</div>
                                            <div className="flex justify-end items-center text-lg mr-2">Clienti</div>
                                        </div>
                                    </div>
                                </Button>
                                <Button type="full" onClick={() => { navigate('/manager/anagrafica') }} color="green">
                                    <div className="flex justify-between items-center w-full">
                                        <Wrench size={48} strokeWidth={2} />
                                        <div className="flex flex-col">
                                            <div className="text-4xl font-semibold">{conteggi.Componenti}</div>
                                            <div className="flex justify-end items-center text-lg mr-2">Articoli</div>
                                        </div>
                                    </div>
                                </Button>
                                <Button type="full" onClick={() => { navigate('/manager/installatori') }} color="yellow">
                                    <div className="flex justify-between items-center w-full">
                                        <Users size={48} strokeWidth={2} />
                                        <div className="flex flex-col">
                                            <div className="text-4xl font-semibold">{conteggi.Utenti}</div>
                                            <div className="flex justify-end items-center text-lg mr-2">Installatori</div>
                                        </div>
                                    </div>
                                </Button>
                            </div>
                            <div className="grid grid-cols-2 gap-5 mt-5 h-[80vh]">
                                <div
                                    className="p-4 rounded-2xl bg-gray-200 dark:bg-neutral-800 hover:cursor-pointer hover:scale-[101%] transition-transform delay-150 duration-300 ease-in-out"
                                    onClick={() => { setIsScadenzeVisible(true) }}
                                >
                                    <BarChart
                                        data={barChartData}
                                        maxValue={Math.max(...barChartData.map(d => d.value))}
                                        title="Scadenze articoli"
                                    />
                                </div>
                                <div className="p-4 rounded-2xl bg-gray-200 dark:bg-neutral-800">
                                    <div className="flex justify-self-center text-xl font-bold my-4 text-center text-black dark:text-white uppercase">ULTIMI INTERVENTI</div>
                                    <Table
                                        headers={[
                                            { label: 'Data/Date Intervento', key: 'DataIntervento' },
                                            { label: 'Nome Cliente', key: 'NomeAzienda' },
                                            { label: 'Email Installatore', key: 'EmailUtente' }
                                        ]}
                                        keyForPreview={["DataIntervento"]}
                                        data={dataInterventi}
                                        setData={setDataInterventi}
                                        renderRowPC={({ rowData, handleRowCheckboxChange }) => <RowPCI data={rowData} onCheckboxChange={handleRowCheckboxChange} />}
                                        renderRowMobile={({ rowData, headers, keyForPreview }) => <RowMobile data={rowData} headers={headers} keyForPreview={keyForPreview} />}
                                        itemsPC={8}
                                        itemsMobile={8}
                                        needResearch={true}
                                        clickableRow={true}
                                        actionRow={async (row, rowIndex) => { await loadManutenzioniByReport(row.value.ID); setSelectedIntervento(row); setIsInterventiVisible(true); }}
                                        isBgLighter={true}

                                    />
                                </div>
                            </div>
                        </div>
                    )
                }

                <PopUp title={`INTERVENTO ${selectedIntervento ? selectedIntervento.value.DataIntervento : ''}`}
                    isVisible={isInterventiVisible}
                    setIsVisible={setIsInterventiVisible}
                    needConfirm={false}
                >
                    <Table
                        headers={[
                            { label: 'Data', key: 'Data' },
                            { label: 'Descrizione', key: 'Descrizione' },
                            { label: 'Email Installatore', key: 'EmailUtente' },
                            { label: 'Nome Cliente', key: 'NomeAzienda' },
                            { label: 'Nome Componente', key: 'NomeComponente' },
                            { label: 'Descrizione Componente', key: 'DescrizioneComponente' },
                            { label: 'Sito', key: 'Impianto' },
                            { label: 'Stato', key: 'StatoAssunto' }
                        ]}
                        keyForPreview={['Data', 'EmailUtente', 'NomeComponente', 'Descrizione']}
                        data={infoManut}
                        setData={setInfoManut}
                        renderRowPC={({ rowData, handleRowCheckboxChange }) => <RowPCI data={rowData} />}
                        renderRowMobile={({ rowData, headers, keyForPreview }) => <RowMobile data={rowData} headers={headers} keyForPreview={keyForPreview} />}
                        forceSmall={true}
                        itemsPC={8}
                        itemsMobile={3}
                        needResearch={true}
                        classes="mt-2"
                    />
                </PopUp >
                <PopUp title="PROSSIME SCADENZE"
                    isVisible={isScadenzeVisible}
                    setIsVisible={setIsScadenzeVisible}
                    needConfirm={false}
                >
                    <Table
                        headers={[
                            { label: 'Codice Articolo', key: 'Codice' },
                            { label: 'Descrizione Articolo', key: 'Descrizione' },
                            { label: 'Prossima Manutenzione', key: 'ProssimaManutenzione' },
                            { label: 'Cliente', key: 'NomeAzienda' },
                            { label: 'Impianto', key: 'impianto' },
                            { label: 'Categoria', key: 'categoria' },
                            { label: 'Stato', key: 'StatoAssunto' },
                        ]}
                        keyForPreview={["Codice", "Descrizione", "ProssimaManutenzione", "NomeAzienda"]}
                        data={dataScadenze}
                        setData={setDataScadenze}
                        renderRowPC={({ rowData, handleRowCheckboxChange }) => <RowPCI data={rowData} />}
                        renderRowMobile={({ rowData, headers, keyForPreview }) => <RowMobile data={rowData} headers={headers} keyForPreview={keyForPreview} />}
                        forceSmall={true}
                        itemsPC={8}
                        itemsMobile={3}
                        needResearch={true}
                        clickableRow={true}
                        actionRow={async (row, rowIndex) => { setSelectedScadenza(row); setIsMailVisible(true) }}
                        classes="mt-2"
                    />
                </PopUp >
                <PopUp title={`MAIL SCADENZA ARTICOLO ${selectedScadenza ? selectedScadenza.value["Codice"] + " - " + selectedScadenza.value["Descrizione"] : ""}`}
                    isVisible={isMailVisible}
                    setIsVisible={() => { setIsMailVisible(false); setSelectedUsers([]); setUtenti([]); }}
                    needConfirm={false}
                >
                    <div className="flex flex-col justify-center items-center mt-4">
                        <Button type="hollow" classes="w-[80%] md:w-[70%]" onClick={handleSendAll}>
                            INVIA A TUTTI GLI INSTALLATORI
                        </Button>
                        <div className="relative flex items-center justify-center w-full mt-4">
                            <div className="absolute w-full h-1 bg-gray-200 dark:bg-neutral-800 rounded"></div>
                            <span className="relative px-3 bg-gray-100 dark:bg-neutral-900 ">oppure</span>
                        </div>
                        <Combobox
                            label="Aggiungi Installatore"
                            options={utenti.map((d) => ({ label: `${d["Nome"]} ${d["Cognome"]}`, value: d["ID"] }))}
                            onChange={(value) => { addUser(value) }}
                            classes="w-[80%] md:w-[70%] mt-2"
                        />
                        <div className="mt-3 flex flex-col gap-1 w-full">
                            {
                                selectedUsers.map((user) => (
                                    <div key={user["ID"]} className="flex items-center justify-between bg-gray-200 dark:bg-neutral-800 rounded-lg px-4 py-2">
                                        <span>{`${user["Nome"]} ${user["Cognome"]}`}</span>
                                        <X size={20} strokeWidth={2} className="inline-block hover:cursor-pointer text-red-600 " onClick={() => { handleRimuoviUtente(user["ID"]) }} />
                                    </div>
                                ))
                            }
                        </div>
                        {
                            selectedUsers.length > 0 && (
                                <Button type="hollow" classes="w-[80%] md:w-[70%] mt-4" onClick={handleSend}>
                                    INVIA
                                </Button>
                            )
                        }
                    </div>
                </PopUp >

            </div >
        </div >
    )
};

export default Dash;